import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/services/auth/auth.service';
import { SharedService } from 'app/services/shared.service';
import { SweetAlertMsgService } from 'app/services/sweet-alert-msg.service';

export interface DialogData {}

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ChangePasswordComponent implements OnInit {
    PasswordForm: FormGroup;
    currentLang: string;

    constructor(
        public dialogRef: MatDialogRef<ChangePasswordComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private _formBuilder: FormBuilder,
        private _auth: AuthService,
        private _shared: SharedService,
        private _msg: SweetAlertMsgService,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.initializeLanguage();
        this.PasswordForm = this._formBuilder.group({
            password: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(99),
                    Validators.minLength(8),
                ],
            ],
            password2: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(99),
                    Validators.minLength(8),
                ],
            ],
            password3: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(99),
                    Validators.minLength(8),
                ],
            ],
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    initializeLanguage() {
        // 1. Intentar obtener el idioma guardado
        const savedLang = localStorage.getItem('lang');
        this.translate.setDefaultLang('es'); // Establecer 'es' como idioma principal

        let finalLang: string;

        if (savedLang) {
            // Caso 1: Usar el idioma guardado
            finalLang = savedLang;
        } else {
            // Caso 2: Usar el idioma del navegador si es 'es' o 'en'
            const browserLang = this.translate.getBrowserLang();
            finalLang =
                browserLang && browserLang.match(/es|en/) ? browserLang : 'es';
        }

        this.translate.use(finalLang);
        this.currentLang = finalLang; // Sincroniza la variable con el idioma usado
    }

    preCambiar() {
        if (this.PasswordForm.invalid) {
            return false;
        }
        let info = this.PasswordForm.value;
        if (info.password2 !== info.password3) {
            this._msg.alertWarning(
                this.translate.instant('ATENCION'),
                this.translate.instant('AUTH.FORGOT_PASSWORD.CONTRASENAS_DEBEN_COINCIDIR')
            );
            return false;
        }
        this.cambiarPassword();
    }
    cambiarPassword() {
        let info = this.PasswordForm.value;
        this._shared.cargando = true;
        this._auth.changePassword(info.password, info.password3).subscribe({
            next: (data) => {
                if (data.code !== undefined) {
                    this._auth.evaluarMensajesCognito(
                        data,
                        '',
                        'changePassword'
                    );
                } else {
                    this.cerrar();
                    this._msg.alertSuccess(
                        this.translate.instant('EXITO'),
                        this.translate.instant(
                            'AUTH.FORGOT_PASSWORD.CONTRASENA_CAMBIADA_EXITOSAMENTE'
                        )
                    );
                }
                this._shared.cargando = false;
            },
            error: (data) => {
                this._shared.cargando = false;
                console.log(data);
            },
        });
    }
    cerrar() {
        this.dialogRef.close();
    }
}
